module.exports = __webpack_public_path__ + "static/media/golf-week.596c318b.svg";